import React, { useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Form, Button, Alert } from 'react-bootstrap';
import { login, getSession } from './auth';
import { nextPath } from './savedAlbums';

const Login = ({ location }) => {
  // Coming from a shared album's Save button: return to it afterwards (see savedAlbums.js).
  const next = nextPath(location && location.search);
  const carry = next ? `?next=${encodeURIComponent(next)}` : '';
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(true);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(!!getSession());

  if (done) return <Redirect to={next || '/user'} />;

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username.trim(), password, remember);
      setDone(true);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 360, width: '90%', margin: '0 auto' }}>
      <h2 className="text-center mb-4">
        <span role="img" aria-label="soup">🍲</span> Stew
      </h2>
      <Form onSubmit={submit}>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form.Group controlId="username">
          <Form.Label>Username</Form.Label>
          <Form.Control
            autoFocus
            autoCapitalize="none"
            autoCorrect="off"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </Form.Group>
        <Form.Group controlId="password">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Form.Check
            className="mt-2"
            type="checkbox"
            label="Show password"
            checked={showPassword}
            onChange={(e) => setShowPassword(e.target.checked)}
          />
        </Form.Group>
        <Form.Check
          className="mb-3"
          type="checkbox"
          id="remember"
          label="Remember me"
          checked={remember}
          onChange={(e) => setRemember(e.target.checked)}
        />
        <Button type="submit" block disabled={loading}>
          {loading ? 'Signing in…' : 'Log in'}
        </Button>
        <div className="text-center mt-3"><Link to="/forgot">Forgot password?</Link></div>
        <div className="text-center mt-2">New here? <Link to={`/signup${carry}`}>Create an account</Link></div>
      </Form>
    </div>
  );
};

export default Login;
